import { render, staticRenderFns } from "./weekKPI.vue?vue&type=template&id=52ef2453&scoped=true"
import script from "./weekKPI.vue?vue&type=script&lang=js"
export * from "./weekKPI.vue?vue&type=script&lang=js"
import style0 from "./weekKPI.vue?vue&type=style&index=0&id=52ef2453&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ef2453",
  null
  
)

export default component.exports